var _require = require('./helpers'),
    isFormId = _require.isFormId;

var _require2 = require('./simplify_text_attributes'),
    simplifyRepresentations = _require2.representations;

var _require3 = require('./simplify_claims'),
    simplifyClaims = _require3.simplifyClaims;

var simplifyForm = function simplifyForm(form, options) {
  var id = form.id,
      representations = form.representations,
      grammaticalFeatures = form.grammaticalFeatures,
      claims = form.claims;
  if (!isFormId(id)) throw new Error('invalid form object');
  return {
    id: id,
    representations: simplifyRepresentations(representations),
    grammaticalFeatures: grammaticalFeatures,
    claims: simplifyClaims(claims, options)
  };
};

var simplifyForms = function simplifyForms(forms, options) {
  return forms.map(function (form) {
    return simplifyForm(form, options);
  });
};

module.exports = {
  simplifyForm: simplifyForm,
  simplifyForms: simplifyForms
};